import { Flex, Box, Table } from '@volue/wave-react';
import React from 'react';

import { EvaluatedResultComponent } from '@/features/execute-calculation-set/components/EvaluatedResultComponent';
import type { SelectedGridElement } from '@/features/execute-calculation-set/overmind/calculation';

type SelectedAcLineSegment = {
  type: 'SELECTED_GRID_ELEMENT';
  gridElement: SelectedGridElement<'AcLineSegment'>;
};

export const ACLineDetails: React.FunctionComponent<{
  acline: SelectedAcLineSegment;
}> = ({ acline }) => {
  return (
    <span data-component={ACLineDetails.name} style={{ display: 'contents' }}>
      {acline.gridElement.loadflow.type ===
        'ALL_LOAD_FLOW_SCENARIO_DETAILS' && (
        <Flex flow="column" gap={'spacingXs'}>
          <Box css={{ color: '$colorAccent70', fontWeight: 'bolder' }}>
            {'LoadFlow'}
          </Box>
          <Table aria-label="Load scenarios" highlightOnHover={false}>
            <Table.Header>
              <Table.ColumnHeader>{'Scenario'}</Table.ColumnHeader>
              <>
                {acline.gridElement.loadflow.details.map(scenario => (
                  <Table.ColumnHeader>
                    {scenario.scenarioName}
                  </Table.ColumnHeader>
                ))}
              </>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Flex
                  as={Table.Cell}
                  flow="column"
                  gap={'none'}
                  justifyContent="start"
                  alignItems="start"
                >
                  <Box>Rated Current</Box>
                </Flex>
                <>
                  {acline.gridElement.loadflow.details.map(scenario => (
                    <Table.Cell>
                      {scenario.scenarioDetails.inputs.ratedCurrent.toString()}
                    </Table.Cell>
                  ))}
                </>
              </Table.Row>
              <Table.Row>
                <Flex
                  as={Table.Cell}
                  flow="column"
                  gap={'none'}
                  justifyContent="start"
                  alignItems="start"
                >
                  <Box>Current</Box>
                </Flex>
                <>
                  {acline.gridElement.loadflow.details.map(scenario => (
                    <Table.Cell>
                      <EvaluatedResultComponent
                        result={scenario.scenarioDetails.results.current}
                      />
                    </Table.Cell>
                  ))}
                </>
              </Table.Row>
              <Table.Row>
                <Flex
                  as={Table.Cell}
                  flow="column"
                  gap={'none'}
                  justifyContent="start"
                  alignItems="start"
                >
                  <Box>Loading</Box>
                </Flex>
                <>
                  {acline.gridElement.loadflow.details.map(scenario => (
                    <Table.Cell>
                      <EvaluatedResultComponent
                        result={scenario.scenarioDetails.results.loadingPercent}
                      />
                    </Table.Cell>
                  ))}
                </>
              </Table.Row>
              <Table.Row>
                <Flex
                  as={Table.Cell}
                  flow="column"
                  gap={'none'}
                  justifyContent="start"
                  alignItems="start"
                >
                  <Box>Available Capacity</Box>
                </Flex>
                <>
                  {acline.gridElement.loadflow.details.map(scenario => (
                    <Table.Cell>
                      <EvaluatedResultComponent
                        result={
                          scenario.scenarioDetails.results.availableCapacity
                        }
                      />
                    </Table.Cell>
                  ))}
                </>
              </Table.Row>
            </Table.Body>
          </Table>
        </Flex>
      )}
    </span>
  );
};
